import { ShiftManagementPageQuery } from 'generated/resources/graphql'

export type PermissionsType = ShiftManagementPageQuery

export interface PermissionsState {
  permissions: PermissionsType | undefined
  canAccessTimeInsights: boolean
  canManageDefaultShifts: boolean
  canManageTemplates: boolean
  canManageShifts: boolean
  canManageUnassignedShifts: boolean
  canCreateShiftsForEverybody: boolean
  canCreateShiftsForTeam: boolean
  canCreateShiftsForReportees: boolean
  canCreateShiftsForSelf: boolean
  canCreateUnassignedShiftsForEverybody: boolean
  canCreateUnassignedShiftsForTeam: boolean
  canCreateUnassignedShiftsForReportees: boolean
  canSeeTimeBalanceExport: boolean
  canExportTimeBalanceForEverybody: boolean
  canManageBreakConfigurations: boolean
  canManageLocation: boolean
  canManageWorkArea: boolean
}

export type PermissionsDispatch = (arg0: PermissionsAction) => void

// Define actions if it's really needed
export type PermissionsAction = { type: '' }

const availablePermissions = (permissions?: PermissionsType): PermissionsState => {
  const smPermissions = permissions?.shiftManagement._policies
  const tbPermissions = permissions?.timeBalance._policies
  const tsPermissions = permissions?.timeSettings._policies
  const locationPermissions = permissions?.locations._policies

  return {
    permissions,
    canAccessTimeInsights: !!smPermissions?.accessSeeTimeInsights.can,
    canManageDefaultShifts: !!smPermissions?.defaultShiftManage.can,
    canManageTemplates: !!smPermissions?.accessManageTemplates.can,
    canManageShifts: !!smPermissions?.accessManageShifts?.can,
    canManageUnassignedShifts: !!smPermissions?.accessManageUnassignedShifts?.can,
    canCreateShiftsForEverybody: !!smPermissions?.shiftCreateEverybody?.can,
    canCreateShiftsForTeam: !!smPermissions?.shiftCreateTeam?.can,
    canCreateShiftsForReportees: !!smPermissions?.shiftCreateReportees?.can,
    canCreateShiftsForSelf: !!smPermissions?.shiftCreateSelf?.can,
    canCreateUnassignedShiftsForEverybody: !!smPermissions?.unassignedShiftCreateEverybody?.can,
    canCreateUnassignedShiftsForTeam: !!smPermissions?.unassignedShiftCreateTeam?.can,
    canCreateUnassignedShiftsForReportees: !!smPermissions?.unassignedShiftCreateReportees?.can,
    canSeeTimeBalanceExport: !!tbPermissions?.accessSeeTimeBalanceExport.can,
    canExportTimeBalanceForEverybody: !!tbPermissions?.exportSeeEverybody.can,
    canManageBreakConfigurations: !!tsPermissions?.manageBreakConfigurations.can,
    canManageLocation: !!locationPermissions?.locationManage.can,
    canManageWorkArea: !!locationPermissions?.workAreaManage.can,
  }
}

interface InitialStateProps {
  permissions?: PermissionsType
}

export function initialPermissionsState({ permissions }: InitialStateProps): PermissionsState {
  return availablePermissions(permissions)
}

export default function reducer(
  state: PermissionsState,
  action: PermissionsAction
): PermissionsState {
  switch (action.type) {
    default:
      return state
  }
}
